function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   display: flex;\n   border-left: 1px solid ", ";\n   margin-left: 1rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
var TopNavHamburgerButtonWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.brandColors.darkBlue;
});
export { TopNavHamburgerButtonWrapper };